const PLATFORMS = {
  spotify: "Spotify",
  apple_music: "Apple Music",
  youtube: "YouTube",
}

function PlatformIcon({ platform }) {
  if (platform === "youtube") {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
        <path
          d="M9.8 8.2v7.6l6.3-3.8-6.3-3.8Z"
          fill="currentColor"
        />
        <path
          d="M4 7.8c.2-1.2 1.1-2.1 2.3-2.3C8 5.2 12 5.2 12 5.2s4 0 5.7.3c1.2.2 2.1 1.1 2.3 2.3.3 1.7.3 4.2.3 4.2s0 2.5-.3 4.2c-.2 1.2-1.1 2.1-2.3 2.3-1.7.3-5.7.3-5.7.3s-4 0-5.7-.3c-1.2-.2-2.1-1.1-2.3-2.3-.3-1.7-.3-4.2-.3-4.2s0-2.5.3-4.2Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  if (platform === "apple_music") {
    return (
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
        <path
          d="M16 5.2v10.1a2.9 2.9 0 1 1-1.7-2.6V7.9L9 8.9v7.4a2.9 2.9 0 1 1-1.7-2.6V7.1L16 5.2Z"
          fill="currentColor"
        />
      </svg>
    )
  }

  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
      <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path d="M8 10.1c2.9-.8 5.6-.5 8 1" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M8.8 13c2.3-.6 4.4-.3 6.2.8" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M9.5 15.6c1.6-.3 3-.1 4.2.6" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  )
}

export default function PlatformLinks({ post }) {
  const links = post.platform_links || {}
  const availableLinks = Object.entries(PLATFORMS).filter(([key]) => {
    return key !== post.embed_type && links[key]
  })

  if (availableLinks.length === 0) return null

  return (
    <div className="mt-3 flex items-center gap-2">
      <span className="text-xs text-stone-700">also on</span>
      {availableLinks.map(([key, label]) => (
        <a
          key={key}
          href={links[key]}
          target="_blank"
          rel="noopener noreferrer"
          title={label}
          aria-label={`Open on ${label}`}
          className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-stone-800 text-stone-500 transition-colors hover:border-stone-600 hover:text-stone-100"
        >
          <PlatformIcon platform={key} />
        </a>
      ))}
    </div>
  )
}
